import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/data/content";

const AdminLogin = () => {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(form.email, form.password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Échec de la connexion");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-[#F8FAFC] py-20" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white p-10 border border-gray-200">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="MIREVSA" className="h-12 w-12 object-contain" />
          <div>
            <div className="font-heading font-black text-lg">MIREVSA</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#0B3D91] font-bold">Espace Admin</div>
          </div>
        </Link>

        <div className="h-12 w-12 bg-[#0B3D91] flex items-center justify-center">
          <Lock size={20} className="text-white" />
        </div>
        <h1 className="mt-6 font-heading font-black text-3xl text-[#1C1C1C]">Connexion</h1>
        <p className="mt-2 text-sm text-muted">Réservé aux administrateurs MIREVSA.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="label-eyebrow">Email</label>
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="admin-login-email"
              className="mt-2 w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-[#0B3D91]"
            />
          </div>
          <div>
            <label className="label-eyebrow">Mot de passe</label>
            <input
              required
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              data-testid="admin-login-password"
              className="mt-2 w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-[#0B3D91]"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="btn-primary w-full disabled:opacity-60"
          >
            {submitting ? "Connexion..." : "Se connecter"} <ArrowRight size={18} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
